import * as React from "react";
import Button from "@mui/material/Button";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";
//import {logger} from '../utils';
import FormHelperText from '@mui/material/FormHelperText';

export default function AutoReport({ handleRefreshCallback }) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [month, setMonth] = React.useState(moment())
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('Are you sure you want to create invoices for all active PO for this month ');

    const handleCallback = () => {
        fetch(`/api/InvoiceAuto/${moment(month).format('YYYY-MM-DD')}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        })
        handleRefreshCallback()
        handleClose()
        setRefresh(true);
    };

    React.useEffect(() => {
        if (refresh) {
            setRefresh(false);
        }
    })

    const handleMonth = (Data) => {
        setMonth(Data);
    }

    const handleClickOpen = () => {
        setOpen(true)
    };

    const handleAlertClose = () => {
        setAlert(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>

            <Button variant="contained" onClick={handleClickOpen}>
                Auto 
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                            Generate
                        </Typography>
                        <Button autoFocus color="inherit" onClick={() => {
							setAlert(true)
                        }}>
                            save
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ display: "column", flexDirection: "row" }}>
                        <DatePicker
                            label={'"month" and "year"'}
                            onChange={(newValue) => handleMonth(newValue)}
                            value={month}
                            views={['month', 'year']}
                        />
                    </div>
                </DialogContent>
                <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="L&P Lock"
                    aria-describedby="Time Period locked for this work"
                >
                    <DialogTitle id="Time Entry">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {AlertText + `${moment(month).format('MMMM') }`}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>No</Button>
                        <Button onClick={() => {
                            setAlert(false)
                            handleCallback()
                        }} autoFocus>Yes</Button>
                    </DialogActions>
                </Dialog>
            </Dialog>  
        </div>
    );
}